import {ChecklistRepository} from '../repository/ChecklistRepository';
import {VisitChecklistSubmission} from '../models/checklist.model';

/** CR09 Phase 2 — read the checklists filled during a given visit. */
export class ListVisitSubmissionsUseCase {
  constructor (private checklistRepository: ChecklistRepository) {}

  async execute (visitId: number): Promise<VisitChecklistSubmission[]> {
    return this.checklistRepository.listVisitSubmissions(visitId);
  }
}
